import * as React from "react";
import {
  DateField,
  TextField,
  EditButton,
  TextInput,
  FunctionField,
} from "react-admin";
import { DateRangeInput, NumberRangeInput } from "../../components/input";
import { StatusEnum } from "../../common/enum";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <TextInput source="title" />,
  <DateRangeInput source="created_at" label="Created At" />,
  <NumberRangeInput source="id" label="Id" />,
];

export const PageList = (props) => (
  <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      <FunctionField
        label="Status"
        render={(record) =>
          StatusEnum.find((x) => x.id === record.status)?.name
        }
      />
      <DateField source="created_at" label="Created At" />
      <IfCanAccess action="edit">
        <EditButton />
      </IfCanAccess>
    </Datagrid>
  </List>
);
